/**
 * authService.js — Pure Auth API Functions
 *
 * ไม่มี React dependency ทดสอบได้อิสระ
 * ทุก function return Promise ของ axios response
 */

import { authClient, apiClient } from '../lib/authClient';

const REFRESH_TIMEOUT = 10_000; // 10s
const INIT_TIMEOUT = 15_000; // 15s
const LOGOUT_TIMEOUT = 5_000;  // 5s

/** ครอบ Promise ด้วย timeout */
const withTimeout = (promise, ms, label = 'request') =>
  Promise.race([
    promise,
    new Promise((_, rej) =>
      setTimeout(() => rej(new Error(`${label} timed out after ${ms}ms`)), ms)
    ),
  ]);

export const authService = {
  /** POST /auth/login */
  login: (credentials) =>
    withTimeout(
      authClient.post('/login', credentials),
      REFRESH_TIMEOUT, 'login'
    ),

  /** POST /auth/refresh */
  refresh: (refreshToken) =>
    withTimeout(
      authClient.post('/refresh', { refresh_token: refreshToken }),
      REFRESH_TIMEOUT, 'refresh'
    ),

  /** POST /auth/logout */
  logout: (refreshToken) =>
    withTimeout(
      authClient.post('/logout', { refresh_token: refreshToken }),
      LOGOUT_TIMEOUT, 'logout'
    ),

  /** POST /auth/heartbeat — อัพเดท last_active (non-critical) */
  heartbeat: (refreshToken) =>
    authClient.post('/heartbeat', {
      refresh_token: refreshToken || undefined,
    }),

  /** GET /api/profile/me */
  getMe: () =>
    withTimeout(
      apiClient.get('/profile/me'),
      INIT_TIMEOUT, 'getMe'
    ),

  /** GET /api/user/navigation */
  getNavigation: () =>
    withTimeout(
      apiClient.get('/user/navigation'),
      INIT_TIMEOUT, 'getNavigation'
    ),
};
